<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">基础信息：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="base"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="formRules"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="合同编号" field="contractNum" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.contractNum" placeholder="请输入合同编号" :disabled="flowEdit" clearable
                     @input="$refs.base.updateStatus(scope)" @blur="checkValue"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="合同名称" field="contractName" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.contractName" placeholder="请输入合同名称" clearable
                     @input="$refs.base.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="业务员" field="salesMan" span="8">
        <template>
          <div class="input-border">
            <sales-man
                :row="formData"
                :field="'salesMan'"
                :placeholder="'请选择业务员'"
                @setSaleMan="setSaleMan"
                @focus="clearValidate"
                @blur="clearValidate"
            ></sales-man>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="合同类型" field="busType" span="8">
        <template v-slot>
          <vxe-select v-model="formData.busType" :options="contractListType"
                      placeholder="请选择合同类型" @change="changeContractType"></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="签约日期" field="palletAddTime" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletAddTime" type="date" placeholder="请选择时间"
                     @input="$refs.base.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
  import SalesMan from "@/components/common/SalesMan";
  import auth from "@/utils/auth";

  export default {
    components: {SalesMan},
    props: ['contractListType', 'isSubmit', 'isCancel', 'isSave', 'detailData', 'flowEdit'],
    data() {
      let userInfoValue = {};
      if (auth.isLogin()) {
        userInfoValue = auth.getAuth();
      }
      return {
        userInfoValue,
        formData: {
          busType: null,
          contractName: null,
          salesMan: null,
          palletAddTime: null
        },
        formRules: {
          busType: [{required: true, message: "请选择合同类型"}],
          contractName: [{required: true, message: "请输入合同名称"}],
          palletAddTime: [{required: true, message: "请选择签约日期"}],
        },
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            contractNum: this.detailData.contractNum,
            busType: this.detailData.contractType,
            contractName: this.detailData.contractName,
            salesMan: this.detailData.salesMan,
            salesManId: this.detailData.salesManId,
            palletAddTime: this.detailData.palletAddTime ? this.$utils.toStringDate(this.detailData.palletAddTime) : null
          }
        }
      }
    },
    methods: {
      checkValue() {
        if (this.formData.contractNum.substring(0, 2) === 'NH') {
          this.$XModal.alert({
            message: '合同编号格式错误',
            status: "error",
          });
          this.formData.contractNum = null;
          return
        }
      },
      async check() {
        const errMap = await this.$refs.base.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          contractNum: this.formData.contractNum,
          contractType: this.formData.busType,
          contractName: this.formData.contractName,
          salesMan: this.formData.salesMan,
          salesManId: this.formData.salesManId,
          palletAddTime: this.formData.palletAddTime ? this.$utils.timestamp(this.formData.palletAddTime) : null
        };
        this.$emit("setParams", obj);
      },
      changeContractType(val) {
        this.$emit("setBusType", val.value);
        this.clearValidate();
      },
      init() {
        if (this.userInfoValue.identityType === 0) {
          this.isSaleMan = true;
          this.formData.salesMan = this.userInfoValue.name;
          this.formData.salesManId = this.userInfoValue.id;
        } else {
          this.isSaleMan = false;
        }
      },
      setSaleMan(val) {
        this.clearValidate();
      },
      clearValidate() {
        this.$refs.base.clearValidate();
      },
      reset() {
        this.formData = {
          contractNum: null,
          busType: null,
          contractName: null,
          salesMan: null,
          palletAddTime: null
        };
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>
  .input-border {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    border: 1px solid #f2f1f1;
  }

  .input-border >>> .link-text {
    color: #438DF3;
  }
</style>